import { IApplicationState } from '../../types/redux';

const defaultValue: IApplicationState['media'] = {
  banksNumber: 0,
};

export function mediaReducer(state: IApplicationState['media'] = defaultValue): IApplicationState['media'] {
  return state;
}
